import { render, staticRenderFns } from "./TextCaption.vue?vue&type=template&id=5debbfb6&scoped=true"
import script from "./TextCaption.vue?vue&type=script&lang=js"
export * from "./TextCaption.vue?vue&type=script&lang=js"
import style0 from "./TextCaption.vue?vue&type=style&index=0&id=5debbfb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5debbfb6",
  null
  
)

export default component.exports